export class SortInfo {
    static readonly DIR_ASC = 'asc';
    static readonly DIR_DESC = 'desc';

    col = '';
    dir = 'asc';

    constructor(col: string, dir: string = SortInfo.DIR_ASC) {
        this.col = col;
        this.dir = dir;
    }
}



// WEBPACK FOOTER //
// /app/src/model/Helpers/SortInfo.ts